import { useMutation } from "@tanstack/react-query";
import { createCompany } from "../../../api/companies/createCompany";

export const useCreateCompany = () => {

  return useMutation({
    mutationFn: createCompany
  })
}; 